import axios from "axios";
import {getHeadersForNFMS, getNFMSEndpoint, getNodeId} from "./Utils";
import {getUserLogin} from "./components/permissions/PermissionContext";

export async function fetchAllPrograms () {
    const headers = await getHeadersForNFMS("GetPrograms")
    const userAlias = await getUserLogin();
    return axios
        .post(getNFMSEndpoint(), {userAlias}, headers)
        .then((response) => {
            if (response.status === 200) {
                return response.data.programs.map(program => program.name);
            }
            return [];
        })
        .catch(() => {
            return [];
        })
}

export async function fetchFeatures (program) {
    const headers = await getHeadersForNFMS("GetFeatures")
    return axios
        .post(getNFMSEndpoint(), {programId: program}, headers)
        .then((response) => {
            if (response.status === 200) {
                return response.data.features.map(feature => feature.name);
            } else {
                return [];
            }
        })
        .catch(() => {
            return [];
        })
}

export async function fetchFeaturesForProgram (program) {
    const headers = await getHeadersForNFMS("GetFeatures")
    return axios
        .post(getNFMSEndpoint(), {programId: program}, headers)
        .then((response) => {
            if (response.status === 200) {
                return response.data.features;
            } else {
                return [];
            }
        })
        .catch(() => {
            return [];
        })
}

export async function fetchConfigs (feature, configStore) {
    const headers = await getHeadersForNFMS("GetConfigurations")
    return axios
        .post(getNFMSEndpoint(), {featureId: feature, configStore: configStore}, headers)
        .then((response) => {
            if (response.status === 200) {
                return response.data.configurations;
            } else {
                return [];
            }
        })
        .catch(() => {
            return [];
        })
}

export async function fetchTemplates (configType) {
    const headers = await getHeadersForNFMS("GetTemplates")
    return axios
        .post(getNFMSEndpoint(), {configType: configType}, headers)
        .then((response) => {
            if (response.status === 200) {
                return response.data.templates;
            } else {
                return [];
            }
        })
        .catch(() => {
            return [];
        })
}

export async function fetchAttributesForNode() {
    const nodeId = getNodeId();
    if (nodeId) {
        const getFeaturesHeaders = await getHeadersForNFMS("GetFeatures");
        const getProgramsHeaders = await getHeadersForNFMS("GetPrograms");
        const userAlias = await getUserLogin();
        return axios
            .all([
                axios.post(
                    getNFMSEndpoint(), {nodeId: nodeId}, getFeaturesHeaders
                ),
                axios.post(
                    getNFMSEndpoint(), {nodeId: nodeId, userAlias}, getProgramsHeaders
                ),
            ])
            .then(
                axios.spread((featuresResponse, programsResponse) => {
                    const featureList = featuresResponse.data.features;
                    const programList = programsResponse.data.programs;
                    return programList.concat(featureList);
                })
            )
            .catch(() => {
                return [];
            });
    } else {
        return [];
    }
}


// WEBPACK FOOTER //
// ./src/NetworkUtils.js